import { Block } from '@/components/crRender';
import SkeletonBase from '@/components/skeletonBase';
import '../../style.css';
import { generator } from '@/utils/NumbersUtils';

interface SkeletonProps {
    isRender?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({ isRender }) => {
    return (
        <Block isRender={isRender} className="provider-rr-container">
            {/* Main Content Grid */}
            <div className="provider-rr-grid">
                {/* Left Column - Hospital Card Skeleton */}
                <div className="hospital-card">
                    <div className="hospital-card-content">
                        <SkeletonBase 
                            variant="rounded" 
                            width="140px" 
                            height="140px" 
                            style={{ borderRadius: '8px' }}
                        />
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {/* Hospital Name */}
                            <SkeletonBase 
                                variant="text" 
                                width="70%" 
                                height="24px" 
                            />
                            
                            {/* Location */}
                            <SkeletonBase 
                                variant="text" 
                                width="50%" 
                                height="16px" 
                            />

                            {/* Badges */}
                            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                <SkeletonBase 
                                    variant="rounded" 
                                    width="60px" 
                                    height="28px" 
                                    style={{ borderRadius: '20px' }}
                                />
                                <SkeletonBase 
                                    variant="rounded" 
                                    width="80px" 
                                    height="28px" 
                                    style={{ borderRadius: '20px' }}
                                />
                                <SkeletonBase 
                                    variant="rounded" 
                                    width="75px" 
                                    height="28px" 
                                    style={{ borderRadius: '20px' }}
                                />
                            </div>

                            {/* Description */}
                            <div style={{ marginTop: '8px' }}>
                                <SkeletonBase variant="text" width="100%" height="14px" style={{ marginBottom: '8px' }} />
                                <SkeletonBase variant="text" width="95%" height="14px" style={{ marginBottom: '8px' }} />
                                <SkeletonBase variant="text" width="80%" height="14px" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column - Contact Information Skeleton */}
                <div>
                    <div style={{ 
                        background: '#ffffff', 
                        borderRadius: '12px', 
                        padding: '24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <SkeletonBase 
                            variant="text" 
                            width="60%" 
                            height="20px" 
                            style={{ marginBottom: '20px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="100%" 
                            height="16px" 
                            style={{ marginBottom: '16px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="90%" 
                            height="16px" 
                            style={{ marginBottom: '16px' }}
                        />
                        <SkeletonBase 
                            variant="text" 
                            width="85%" 
                            height="16px" 
                        />
                    </div>
                </div>
            </div>

            {/* Submitted Documents Section Skeleton */}
            <div className="submitted-documents">
                <SkeletonBase 
                    variant="text" 
                    width="200px" 
                    height="20px" 
                    style={{ marginBottom: '20px' }}
                />
                <div className="documents-grid">
                    {[1, 2, 3, 4, 5].mapWithKey((index) => (
                        <div 
                            key={index.key}
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '12px',
                                padding: '16px',
                                background: '#f7fafc',
                                border: '1px solid #e2e8f0',
                                borderRadius: '8px'
                            }}
                        >
                            <SkeletonBase 
                                variant="rounded" 
                                width="24px" 
                                height="24px" 
                            />
                            <SkeletonBase 
                                variant="text" 
                                width="70%" 
                                height="14px" 
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Block>
    );
};

export default Skeleton;

